import { AfterViewChecked, Component, ElementRef, OnInit } from '@angular/core';
import { ActiveRentalService, BookingService, LayoutService, NavigationResolver, NavigationService } from 'app-components';
import * as moment from 'moment';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { BookingErrorCode, ObjectTypeInfo, PageBase, PriceModel, RentalInfo, RentalObjectInfo, RentalStatus } from 't4core';
import { BookingValidation } from '../../../../../projects/t4core/src/public-api';

@Component({
    selector: 'app-swap-trailer',
  templateUrl: './swap-trailer.html',
  styleUrls: ['./swap-trailer.css'],
    standalone: false
})

export class SwapTrailerComponent extends PageBase implements OnInit, AfterViewChecked {
  constructor(
    private navigator: NavigationService,
    el: ElementRef,
    private appService: AppIntegrationService,
    private bookingDataService: BookingService,
    public resolver: NavigationResolver,
    public layout: LayoutService,
    public appSettings: AppSettingsService,
    public activeRentalService: ActiveRentalService) {
    super(el);
  }

  public availableObjects: RentalObjectInfo[] = [];
  public loading: boolean = false;
  public swappingLoading: boolean = false;
  public loadingPrice: boolean = false;
  public swapCompleted: boolean = false;
  public swapError: boolean = false;
  public booking: RentalInfo;
  public prices: PriceModel[] = [];

  primaryTypeObjects: RentalObjectInfo[] = [];
  otherTypeObjects: RentalObjectInfo[] = [];


  private groupedObjects: GroupedRentalObject[] = [];
  public primaryGroups: GroupedRentalObject[] = [];
  public otherGroups: GroupedRentalObject[] = [];
  public hasPrimary = false;
  public hasOthers = false;


  async ngOnInit(): Promise<void> {
    await this.loadData();
    await this.loadPrices();
  }

  async loadData() {
    this.loading = true;
    this.booking = await this.activeRentalService.getBooking();

    this.availableObjects = await this.Api.get<RentalObjectInfo[]>("RentalObject/GetAvailableRentalObjects", { location: this.booking.PickupLocationId, pickupTime: this.booking.PickupTime, returnTime: this.booking.ReturnTime });

    //Object from Web/Large view
    this.sortAndGroupObjects();

    //Objects for Mobile View
    this.groupObjectsByType();

    this.loading = false;
  }

  async loadPrices() {
    this.loadingPrice = true;

    const uniqueTypeIds = new Set<number>();
    //Get the unqiue id of all Types of the selected Trailers.
    for (var obj of this.availableObjects) {
      uniqueTypeIds.add(obj.Type.Id);
    }

    const typePriceMap = new Map<number, PriceModel>();
    //Lops through the Types, and get the price. 
    for (var typeId of uniqueTypeIds) {
     var typePrices = await this.Api.get<PriceModel>("Price/GetRentalPrice", {
        pickupTime: this.booking.PickupTime ? this.booking.PickupTime.toISOString() : moment().toISOString(),
        returnTime: this.booking.ReturnTime.toISOString(),
        objectTypeId: typeId,
        pickupLocationId: this.booking.PickupLocation.Id,
        returnLocationId: this.booking.ReturnLocation ? this.booking.ReturnLocation.Id : this.booking.PickupLocation.Id,
        useInsurance: false,
        webBooking: await this.bookingDataService.isWebBooking(),
        actualReturnTime: this.booking.ReturnedAt ? this.booking.ReturnedAt.toISOString() : (this.booking.Status == RentalStatus.Late ? moment().toDate().toISOString() : this.booking.ReturnTime.toISOString()),
        createdAt: this.booking.CreatedAt ? this.booking.CreatedAt.toISOString() : moment().toDate().toISOString(),
        discountId: this.booking.DiscountId,
        addedProducts: this.booking.AddedProducts,
        bookingLat: null,
        bookingLng: null
      });
      typePriceMap.set(typeId, typePrices);
    }

    //Maps the price to the correct Type.

    //Web View - Larger View
    this.otherTypeObjects = this.otherTypeObjects.map(obj => ({
      ...obj,
      priceModel: typePriceMap.get(obj.Type.Id)
    }));

    //Mobile Components.
    this.otherGroups = this.otherGroups.map(obj => ({
      ...obj,
      priceModel: typePriceMap.get(obj.type.Id)
    }));

    this.loadingPrice = false;
  }

  sortAndGroupObjects() {
    const primaryId = this.booking.PrimaryObjectTypeId;
    const currentRentalObject = this.booking.RentalObject.Id;

    const sortedObjects = this.availableObjects.sort((a, b) =>
      a.Type.Id - b.Type.Id
    );

    this.primaryTypeObjects = sortedObjects.filter(obj => obj.Type.Id === primaryId && obj.Id != currentRentalObject);
    this.otherTypeObjects = sortedObjects.filter(obj => obj.Type.Id !== primaryId && obj.Id != currentRentalObject);
  }

 

  groupObjectsByType(): void {
    const primaryTypeId = this.booking?.PrimaryObjectTypeId;
    const currentObjectId = this.booking?.RentalObject?.Id;

    // Reset output each time
    this.groupedObjects = [];

    const groups = new Map<number | string, GroupedRentalObject>();

    for (const obj of this.availableObjects ?? []) {
      if (!obj) continue;

      // Exclude currently selected object / Trailer
      if (currentObjectId != null && obj.Id === currentObjectId) continue;

      //Null check in case, should never hit in theory
      const type = obj.Type;
      if (!type || type.Id == null) continue;

      const key = type.Id;

      // If is the first time the type have been seen, we create the group.
      if (!groups.has(key)) {
        groups.set(key, {
          type,
          objects: [],
          isPrimary: primaryTypeId != null && key === primaryTypeId
        });
      }
      groups.get(key)!.objects.push(obj);
    }

    this.groupedObjects = Array.from(groups.values());

    this.primaryGroups = (this.groupedObjects ?? []).filter(g => g.isPrimary);
    this.otherGroups = (this.groupedObjects ?? []).filter(g => !g.isPrimary);
    this.hasPrimary = this.primaryGroups.length > 0;
    this.hasOthers = this.otherGroups.length > 0;
  }

  async ngAfterViewChecked() {

  }

  public back() {
    this.navigator.back();
  }

  public async initiateSwap(trailer: RentalObjectInfo) {
    var confirm = await this.UI.confirm("Intellitrailer.Booking.Views.SwapTrailer.Headline", "Confirm Swap", "Intellitrailer.Booking.Views.SwapTrailer.msgConfirmChange", 'Are you sure you want to swap to this trailer - {0}?', null, [trailer.Title ]);
    if (confirm) {
      this.loading = true;

      var comment = this.activeRentalService.getReasonForSwap();

      var result = await this.Api.post<BookingValidation>("Rental/ChangeTrailer", null, { rentalId: this.booking.Id, trailerId: trailer.Id, additionalInfo: comment ?? null });
      this.loading = false;
      if (result.AggregatedResult == BookingErrorCode.Valid) {
        this.swapCompleted = true;
        this.activeRentalService.setActiveRental(this.booking.Id);
        setTimeout(() => this.navigator.executeCommand("SwapDone", {rentalId: this.booking.Id}), 4000);
      }
      else {
        this.swapError = true;
        setTimeout(() => {
          this.loadData();         
          this.swapError = false;  
        }, 4000);

      }

    }
  }


}

interface GroupedRentalObject {
  type: ObjectTypeInfo;
  objects: RentalObjectInfo[];
  isPrimary: boolean;
}

